import { h, Fragment } from 'preact';
import { Filter } from './Filter';
import styles from './FilterPanel.module.scss';
export function FilterPanel({ filters, onFilterChange, layout, openFilterDrawer, setOpenFilterDrawer, filtersStartOpen = false }) {
    return (h(Fragment, null,
        layout === 'filterDrawer' && (h("div", { class: styles.filterPanelHeader },
            h("div", { class: "filter-panel-heading" }, "Filters"),
            h("div", { class: "filter-panel-close", onClick: () => setOpenFilterDrawer(!openFilterDrawer) },
                h("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", class: styles.iconClose },
                    h("g", { "clip-path": "url(#clip0_103_2583)" },
                        h("path", { d: "M1 1L15 15M1 15L15 1", stroke: "black" })),
                    h("defs", null,
                        h("clipPath", { id: "clip0_103_2583" },
                            h("rect", { width: "16", height: "16", fill: "white" }))))))),
        h("div", { class: layout === 'filterTop' ? styles.filterPanel : styles.filterPanelSide }, filters.map(filter => (h(Filter, { layout: layout, key: filter.id, filter: filter, onFilterChange: onFilterChange, isOpenByDefault: filtersStartOpen }))))));
}
